import React from 'react';
import { AppProps } from 'next/app';
import '../styles/globals.css';
import { useRouter } from 'next/router';
import Layout from '@/components/app/Layout';
import { Footer } from '@/components/app/Footer';
import AdminLayout from '@/components/app/admin/AdminLayout';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from '@/js/i18n/resources';

function MyApp({ Component, pageProps }: AppProps) {
    const { locale, asPath } = useRouter();
    const currentUrl = asPath;

    i18n.use(initReactI18next).init({
      resources,
      fallbackLng: locale,
      interpolation: {
        escapeValue: false,
      },
    });

    const { categories } = pageProps;

    const isAdminPath = currentUrl.startsWith('/admin');
    const isProduction = process.env.NODE_ENV === 'production';

    return (
      <>
        { isAdminPath && !isProduction &&
          // Admin 페이지에서는 AdminLayout 사용 (운영 환경에서는 미노출)
          <AdminLayout>
            <Component {...pageProps} />
          </AdminLayout>
        }
        { (!isAdminPath || isProduction) &&
          // 그 외의 경우 일반 Layout 사용
          <>
            <Layout categories={categories}>
              <Component {...pageProps} />
            </Layout>
            <Footer />
          </>
        }
      </>
    );
}

export default MyApp;